import api from "../services/api";
import { useAuth } from "../context/AuthContext";

type SendEmailButtonProps = {
  clientId: string;
};

export default function SendEmailButton({ clientId }: SendEmailButtonProps) {
  const { token } = useAuth();

  const handleSend = async () => {
    try {
      await api.post(`/clients/${clientId}/send-email`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert("Email sent ✅");
    } catch {
      alert("Failed to send email");
    }
  };

  return (
    <button onClick={handleSend} className="px-4 py-2 bg-blue-600 text-white rounded">
      Send Email
    </button>
  );
}
